import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { GenerarInterfazComponent } from './GenerarInterfaz.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
{
    path     : 'GenerarInterfaz',
    component: GenerarInterfazComponent,
    canActivate: [RoleGuard], 
    data: { 
        formulario: 'GenerarInterfaz',
        nombreFormulario : 'Generar Interfaz'
    } 
}
];

@NgModule({
    declarations: [
    GenerarInterfazComponent
    ],
    imports     : [
    SharedModule,
    RouterModule.forChild(routes)
    ],
    exports     : [
    GenerarInterfazComponent
    ],
    bootstrap: [GenerarInterfazComponent],
})

export class GenerarInterfazModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/GenerarInterfaz/GenerarInterfaz.module.ts